import { RegionClipResolver } from "./RegionClipResolver";
import { RegionKeepExistingResolver } from "./RegionKeepExistingResolver";
import { RegionPushExistingResolver } from "./RegionPushExistingResolver";
import { StudioPreferences } from "../../StudioPreferences";
export class RegionOverlapResolver {
    #editing;
    #projectApi;
    #boxAdapters;
    constructor(editing, projectApi, boxAdapters) {
        this.#editing = editing;
        this.#projectApi = projectApi;
        this.#boxAdapters = boxAdapters;
    }
    apply(tracks, adapters, strategy, deltaIndex, changes) {
        const behaviour = StudioPreferences.settings.editing["overlapping-regions-behaviour"];
        if (behaviour === "clip") {
            const { postProcess, trackResolver } = RegionClipResolver.fromSelection(tracks, adapters, strategy, deltaIndex);
            this.#editing.modify(() => {
                changes(trackResolver);
                postProcess();
            });
            RegionClipResolver.validateTracks(tracks);
        }
        else if (behaviour === "push-existing") {
            const { postProcess, trackResolver } = RegionPushExistingResolver.fromSelection(tracks, adapters, strategy, deltaIndex, this.#projectApi, this.#boxAdapters);
            this.#editing.modify(() => {
                changes(trackResolver);
                postProcess();
            });
        }
        else {
            // keep-existing
            const { postProcess, trackResolver } = RegionKeepExistingResolver.fromSelection(tracks, adapters, strategy, deltaIndex, this.#projectApi, this.#boxAdapters);
            this.#editing.modify(() => {
                changes(trackResolver);
                postProcess();
            });
        }
    }
    /**
     * For range-based operations (drop, duplicate).
     * Returns the target track to use (may differ from input track for keep-existing mode).
     */
    resolveTargetTrack(track, position, complete) {
        const behaviour = StudioPreferences.settings.editing["overlapping-regions-behaviour"];
        if (behaviour === "keep-existing") {
            return RegionKeepExistingResolver
                .resolveTargetTrack(track, position, complete, this.#projectApi, this.#boxAdapters);
        }
        return track;
    }
    /**
     * Creates a resolver function for range-based operations (to be called inside an existing transaction).
     * Call this BEFORE creating the region to capture the "before" state.
     * Then call the returned function AFTER creating the region.
     */
    fromRange(track, position, complete) {
        const behaviour = StudioPreferences.settings.editing["overlapping-regions-behaviour"];
        if (behaviour === "clip") {
            const solver = RegionClipResolver.fromRange(track, position, complete);
            return () => {
                solver();
                RegionClipResolver.validateTrack(track);
            };
        }
        else if (behaviour === "push-existing") {
            return RegionPushExistingResolver.fromRange(track, position, complete, this.#projectApi, this.#boxAdapters);
        }
        else {
            // keep-existing: nothing to do after creation - caller should use resolveTargetTrack before creating
            return () => { };
        }
    }
}
